import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/[variants]/(activity)/campaigns/sunglasses-sale/ClientPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/RouteMessagesProvider.tsx");
